import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import * as moment from 'moment';
import { AddAttachmentDialogComponent } from '../../../shared-components/add-attachment-dialog/add-attachment-dialog.component';
import { TylerMatTableDataSource } from '../../../shared-components/angular-material/extended.class';
import { ErrorList } from '../../../shared-components/controls/error-prompt/error-list.model';
import { Attachment } from '../../../shared-components/models/attachment.model';
import { System } from '../../../shared-components/System';
import { YearService } from '../../../shared-components/year/year.service';
import { StudentSummaryService } from '../student-summary.service';
import { CheckInOutSubmissionRequest } from './check-in-out-submission-request-modal.model';

@Component({
  selector: 'app-check-in-out-submission-request-modal',
  templateUrl: './check-in-out-submission-request-modal.component.html',
  styleUrls: ['./check-in-out-submission-request-modal.component.css']
})
export class CheckInOutSubmissionRequestModalComponent implements OnInit {
  todaysDate = new Date();
  checkInOutSubmissionRequest: CheckInOutSubmissionRequest;
  columnsToDisplay = ['FileName', 'Description', 'DocumentType', 'UploadedDate', 'Actions'];
  angularMatData = new TylerMatTableDataSource();

  errors: ErrorList[] = [];
  @ViewChild('timeInput', { read: ElementRef, static: true }) timeRef: ElementRef;

  constructor(private dialogRef: MatDialogRef<CheckInOutSubmissionRequestModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialog: MatDialog,
    private studentSummaryService: StudentSummaryService,
    private yearService: YearService) { }

  ngOnInit() {
    this.checkInOutSubmissionRequest = this.data.checkInOutRequest;
    this.loadAttachmentTable();
  }

  cancelClick() {
    this.dialogRef.close();
  }

  deleteAttachmentClick(attachmentId: number) {
    this.checkInOutSubmissionRequest.SubmissionAttachment.find(o => o.Id == attachmentId).Deleted = true;
    this.loadAttachmentTable();
  }

  saveAttachment(attachment: Attachment) {
    // PRE: an attachment to open
    // POST: takes you to the student attachment page
    if (attachment.FileName && !attachment.AttachmentFileName) {
      attachment.AttachmentFileName = attachment.FileName;
    }

    if (attachment.MyFileBase64String && attachment.AttachmentFileName && attachment.FileType) {
      System.viewFileFromBase(attachment.MyFileBase64String, attachment.FileType, attachment.AttachmentFileName);
    } else if (attachment.Id && attachment.AttachmentFileName) {
      System.viewFileFromId(attachment.Id, attachment.AttachmentFileName);
    }
  }

  addAttachmentClick() {
    // POST: opens a modal to add an attachment

    // Initializing attachment
    const attachment = new Attachment();
    attachment.Id = this.checkInOutSubmissionRequest != undefined ? -(this.checkInOutSubmissionRequest.SubmissionAttachment.length + 1) : -1;
    attachment.DocumentId = 0;
    attachment.FileName = '';
    attachment.Description = '';
    attachment.UploadedDate = new Date();
    attachment.MyFileBase64String = '';
    attachment.FileType = '';
    attachment.Comment = '';
    attachment.ViewFileOnWebsite = true;
    attachment.AttachmentDescription = '';

    // Opening modal
    const dialogBox = this.dialog.open<AddAttachmentDialogComponent>(AddAttachmentDialogComponent, {
      data: {
        attachment: attachment,
        newAttachment: true,
        requireDocumentType: true
      },
      disableClose: true
    });
    dialogBox.afterClosed().subscribe(() => {
      if (dialogBox.componentInstance.saved) {
        attachment.AttachmentDescription = attachment.Description;
        attachment.DocumentBase64 = attachment.MyFileBase64String;
        attachment.DocumentType = attachment.FileType;
        attachment.MyFileBase64String = '';
        this.checkInOutSubmissionRequest.SubmissionAttachment.push(attachment);
        this.loadAttachmentTable();
      }
    });
  }

  loadAttachmentTable() {
    this.angularMatData.data = this.checkInOutSubmissionRequest.SubmissionAttachment.filter(x => x.Deleted == false);
  }

  saveClick() {
    this.validateCheck();
    if (this.errors.length == 0) {
      this.checkInOutSubmissionRequest.Time = this.convertTime(this.checkInOutSubmissionRequest.Time);
      this.studentSummaryService.saveCheckInOutSubmissionRequest(this.checkInOutSubmissionRequest, this.yearService.student360Year.Id).subscribe(result => {
        if (result == true) {
          this.dialogRef.close();
        }
      });
    }
  }

  validateCheck() {
    this.errors = [];

    if (this.checkInOutSubmissionRequest.Time == undefined || this.checkInOutSubmissionRequest.Time == null || this.checkInOutSubmissionRequest.Time == '') {
      this.errors.push({
        fieldName: 'Time',
        fieldRef: this.timeRef,
        errorMsg: ' is required.'
      });
    }

    if (this.checkInOutSubmissionRequest.Time != undefined && this.checkInOutSubmissionRequest.Time != '') {
      if (this.validateTime(this.checkInOutSubmissionRequest.Time) != true) {
        this.errors.push({
          fieldName: 'Time',
          fieldRef: this.timeRef,
          errorMsg: ' Invalid Time.'
        });
      }
    }

    const currentDate = new Date().toLocaleDateString();
    if ((new Date(this.yearService.student360Year.StartDate) >= new Date(currentDate)) || (new Date(this.yearService.student360Year.EndDate) <= new Date(currentDate))) {
      this.errors.push({
        fieldName: 'Today Date',
        fieldRef: null,
        errorMsg: 'Today Date must be within the academic year.'
      });
    }
  }

  validateTime(time) {
    const hourIndex = time.toString().indexOf(':');
    if (hourIndex == -1) {
      return false;
    }
    else {
      const hourValue = time.substring(0, hourIndex);
      if (!$.isNumeric(hourValue)) {
        return false;
      }
      else {
        if (hourValue[0] == '0' || hourValue >= 13 && hourValue <= 24) {
          if ((time.toLowerCase().indexOf('am') != -1 || time.toLowerCase().indexOf('pm') != -1) && hourValue > 12) {
            return false;
          }
          else {
            return System.validate24HourTime(time.toLowerCase().replace(' ', '').replace('am', '').replace('pm', ''));
          }
        }
        else {
          if (hourValue < 10) {
            if (time.toLowerCase().indexOf('pm') == -1 && time.toLowerCase().indexOf('am') == -1) {
              return System.validate12HourTime('0' + time + ' AM');
            }
            else {
              return System.validate12HourTime('0' + time);
            }
          }
          else {
            if (time.toLowerCase().indexOf('pm') == -1 && time.toLowerCase().indexOf('am') == -1) {
              return System.validate12HourTime(time + ' AM');
            }
            else {
              return System.validate12HourTime(time);
            }
          }
        }
      }
    }
  }

  convertTime(time) {
    if (time.indexOf(':') == 1) {
      time = '0' + time;
    }
    let ampm = '';
    if (time.toLowerCase().indexOf('pm') > -1) { ampm = ' PM'; }
    else if (time.toLowerCase().indexOf('am') > -1) { ampm = ' AM'; }

    time = time.toLowerCase().replace('am', '').replace('pm', '');
    time = time.toString().trim().match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];
    if (time.length > 1) { // If time format correct
      time = time.slice(1); // Remove full string match value
      time[5] = ampm != '' ? ampm : (+time[0] < 12 ? ' AM' : ' PM'); // Set AM/PM
      time[0] = +time[0] % 12 || 12; // Adjust hours
    }
    if (time[0] < 10) {
      time[0] = '0' + time[0];
    }


    return time.join('');
  }

}
